export const GENERIC_ERROR_MESSAGE =
  'Ocorreu um erro. Tente novamente mais tarde ou entre em contato com nosso suporte pelo Whatsapp +55 21 973764379';
